module.exports = __webpack_public_path__ + "static/images/containers/Schedule/images/challenges_icon.14987551.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Schedule/images/challenges_icon.png
// module id = 3250
// module chunks = 11